"use strict";

module.exports = exports = self.fetch;

// Needed for TypeScript and Webpack.
exports.default = self.fetch.bind(self);

exports.Headers = self.Headers;
exports.Request = self.Request;
exports.Response = self.Response;



//////////////////
// WEBPACK FOOTER
// ./~/node-fetch/browser.js
// module id = 81
// module chunks = 35783957827783 133642133980541